import { render, staticRenderFns } from "./frm_update.vue?vue&type=template&id=6e5eb36a&"
import script from "./frm_update.vue?vue&type=script&lang=js&"
export * from "./frm_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports